export default "__VITE_ASSET__LyRUjv4K__"